<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190118-feature-vaccine.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">接种了问题疫苗 身体还会产生抗体吗？</div>
                   <div class="post_info">Posted at 09:00h in 传染病</div>
                    <div class="post_wrapper_1">
                      自去年中国疫苗问题屡次发生。当中包括较早前某生化技术公司的狂犬病疫苗造假事件，有超过25万儿童注射了问题疫苗，最近又发生为儿童注射了过期疫苗的事件，屡次发生的疫苗事件令父母们忧心重重，对疫苗的效力完全失去信心，不少家长就设法为小朋友检测抗体，希望确定之前所注射的疫苗是有产生足够抗体来保护小朋友。
                    </div>
                  
                    <div class="post_wrapper_tip">注射了问题疫苗怎么办？</div>
                    <div class="post_wrapper_1">
                       <ul>
                            <li>注意儿童注射疫苗后有没有不良反应，如不适或高烧不退必须往医院救诊。 </li>
                            <li>中国有医院感染中心主任表示如注射了问题疫苗，不主张立即补打，因为一般问题疫苗是效价出现问题而导致抗体的保护力变差，所以应该检查一下体内抗体数量才决定是否需要补打。 </li>
                            <li>若担心问题疫苗没有预防效力，可为已注射疫苗的儿童进行抗体检测（血清抗体检测）来检查体内是否仍有抗体。 </li>
                       </ul>
                    </div>
                      <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190118-injection.jpg"/>
                        <div class="bottom_tip">屡次发生的疫苗事件令父母们忧心重重，对疫苗的效力完全失去信心，不少家长就设法为小朋友检测抗体，希望确定之前所注射的疫苗是有产生足够抗体来保护小朋友。</div>
                    </div>  
                    
                    <div class="post_wrapper_tip">真实案例</div>
                    <div class="post_wrapper_1">
                       国内问题疫苗事件爆发后，一对父母带着6岁的儿子来做血清抗体检测，他们的儿子出生后都打齐需要打的疫苗，但是担心疫苗的有效性，所以还是特地到香港检查一下比较放心。
                    </div>
                    <div class="post_wrapper_tip">最后验出的结果：</div>
                    <div class="post_wrapper_1">
                        <strong>阳性反应：</strong>麻疹、流行性腮线炎、破伤风类毒素、白喉类毒素、甲型肝炎、乙肝病毒和德国麻疹病毒的抗体<br />
                        <strong>阴性反应：</strong>水痘状疱疹、脊髓灰质炎病毒和流感嗜血杆菌Type B的抗体
                    </div>
                    <div class="post_wrapper_1">
                        最后父母从检验出来的结果，再向医生资询要否补打未有抗体的疫苗来作全面保护。
                    </div>
                     <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190118-vaccine.png"/>
                        <div class="bottom_tip">屡次发生的疫苗事件令父母们忧心重重，对疫苗的效力完全失去信心，不少家长就设法为小朋友检测抗体，希望确定之前所注射的疫苗是有产生足够抗体来保护小朋友。</div>
                    </div>  
                    <div class="post_wrapper_tip">了解身体抗体保护</div>
                    <div class="post_wrapper_1">
                        <ul>
                        <li>不论是注射了问题疫苗还是正常疫苗，其免疫力亦不能保永远的。 </li>
                        <li>疫苗产生的抗体是有寿命，根据不同体质，保护效果会逐渐减弱，有的甚至数年后就会消失。 </li>
                        <li>为确保各种疫苗接种后能发挥有效的保护和防御力，就必须进行抗体检测（<a href="#">血清抗体检测</a>）来确保体内有足够各种抗体的水平来对抗病菌。 </li>
                        </ul>
                     </div>
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    ul{
                            list-style-position: inside;
                            display: block;
                            list-style-type: disc;
                            margin-block-start: 1em;
                            margin-block-end: 1em;
                            margin-inline-start: 0px;
                            margin-inline-end: 0px;
                            padding-inline-start: 40px;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
                .post_wrapper_2{
                     margin-top:3px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_tip_c{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    margin-top:10px;
                    letter-spacing: .07em!important;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/genseight.vue